module.exports = __webpack_public_path__ + "media/buy_report_icons/equipment-b797a3eb.svg";